import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SectionsRenderer from '../sections/renderer';
import styles from './index.scss';

class SplitView extends Component {
  render() {
    const { columnOne, columnTwo, ratio } = this.props;

    return (
      <section className={styles.columns} data-ratio={ratio.replace(':', '-')}>
        <div className={styles.columnOne}>
          <SectionsRenderer sections={columnOne}/>
        </div>
        <div className={styles.columnTwo}>
          <SectionsRenderer sections={columnTwo}/>
        </div>
      </section>
    );
  }
}

SplitView.propTypes = {
  columnOne: PropTypes.array.isRequired,
  columnTwo: PropTypes.array.isRequired,
  ratio: PropTypes.string.isRequired
}

export default SplitView;



// WEBPACK FOOTER //
// ./src/components/splitview/index.jsx